/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Space_Members_Manage_Extra_Seats_Buy_SeatsInputs */

const en_space_members_manage_extra_seats_buy_seats = /** @type {(inputs: Space_Members_Manage_Extra_Seats_Buy_SeatsInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("en", i?.count, {});
	if (countPlural == "one") return /** @type {LocalizedString} */ (`Buy ${i?.count} Seat`);
	if (countPlural == "other") return /** @type {LocalizedString} */ (`Buy ${i?.count} Seats`);
	return /** @type {LocalizedString} */ ("space.members.manage_extra_seats.buy_seats");
};

const de_space_members_manage_extra_seats_buy_seats = /** @type {(inputs: Space_Members_Manage_Extra_Seats_Buy_SeatsInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("de", i?.count, {});
	if (countPlural == "one") return /** @type {LocalizedString} */ (`${i?.count} Sitz kaufen`);
	if (countPlural == "other") return /** @type {LocalizedString} */ (`${i?.count} Sitze kaufen`);
	return /** @type {LocalizedString} */ ("space.members.manage_extra_seats.buy_seats");
};

const es_space_members_manage_extra_seats_buy_seats = /** @type {(inputs: Space_Members_Manage_Extra_Seats_Buy_SeatsInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("es", i?.count, {});
	if (countPlural == "one") return /** @type {LocalizedString} */ (`Comprar ${i?.count} plaza`);
	if (countPlural == "other") return /** @type {LocalizedString} */ (`Comprar ${i?.count} plazas`);
	return /** @type {LocalizedString} */ ("space.members.manage_extra_seats.buy_seats");
};

const fr_space_members_manage_extra_seats_buy_seats = /** @type {(inputs: Space_Members_Manage_Extra_Seats_Buy_SeatsInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("fr", i?.count, {});
	if (countPlural == "one") return /** @type {LocalizedString} */ (`Acheter ${i?.count} place`);
	if (countPlural == "other") return /** @type {LocalizedString} */ (`Acheter ${i?.count} places`);
	return /** @type {LocalizedString} */ ("space.members.manage_extra_seats.buy_seats");
};

const nl_space_members_manage_extra_seats_buy_seats = /** @type {(inputs: Space_Members_Manage_Extra_Seats_Buy_SeatsInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("nl", i?.count, {});
	if (countPlural == "one") return /** @type {LocalizedString} */ (`Koop ${i?.count} plaats`);
	if (countPlural == "other") return /** @type {LocalizedString} */ (`Koop ${i?.count} plaatsen`);
	return /** @type {LocalizedString} */ ("space.members.manage_extra_seats.buy_seats");
};

/** @type {(inputs: Space_Members_Manage_Extra_Seats_Buy_SeatsInputs) => LocalizedString} */
const it_space_members_manage_extra_seats_buy_seats = en_space_members_manage_extra_seats_buy_seats;

/** @type {(inputs: Space_Members_Manage_Extra_Seats_Buy_SeatsInputs) => LocalizedString} */
const pt_br2_space_members_manage_extra_seats_buy_seats = en_space_members_manage_extra_seats_buy_seats;

/** @type {(inputs: Space_Members_Manage_Extra_Seats_Buy_SeatsInputs) => LocalizedString} */
const pl_space_members_manage_extra_seats_buy_seats = en_space_members_manage_extra_seats_buy_seats;

/** @type {(inputs: Space_Members_Manage_Extra_Seats_Buy_SeatsInputs) => LocalizedString} */
const hu_space_members_manage_extra_seats_buy_seats = en_space_members_manage_extra_seats_buy_seats;

/** @type {(inputs: Space_Members_Manage_Extra_Seats_Buy_SeatsInputs) => LocalizedString} */
const ro_space_members_manage_extra_seats_buy_seats = en_space_members_manage_extra_seats_buy_seats;

/**
* | countPlural | output |
* | --- | --- |
* | "one" | "Buy {count} Seat" |
* | "other" | "Buy {count} Seats" |
*
* @param {Space_Members_Manage_Extra_Seats_Buy_SeatsInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const space_members_manage_extra_seats_buy_seats = /** @type {((inputs: Space_Members_Manage_Extra_Seats_Buy_SeatsInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Space_Members_Manage_Extra_Seats_Buy_SeatsInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_space_members_manage_extra_seats_buy_seats(inputs)
	if (locale === "de") return de_space_members_manage_extra_seats_buy_seats(inputs)
	if (locale === "es") return es_space_members_manage_extra_seats_buy_seats(inputs)
	if (locale === "fr") return fr_space_members_manage_extra_seats_buy_seats(inputs)
	if (locale === "nl") return nl_space_members_manage_extra_seats_buy_seats(inputs)
	if (locale === "it") return it_space_members_manage_extra_seats_buy_seats(inputs)
	if (locale === "pt-BR") return pt_br2_space_members_manage_extra_seats_buy_seats(inputs)
	if (locale === "pl") return pl_space_members_manage_extra_seats_buy_seats(inputs)
	if (locale === "hu") return hu_space_members_manage_extra_seats_buy_seats(inputs)
	return ro_space_members_manage_extra_seats_buy_seats(inputs)
});
export { space_members_manage_extra_seats_buy_seats as "space.members.manage_extra_seats.buy_seats" }